import Service from '../services/ServiceReminderService'
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        reminders: [],
        sending: false,
        loading: false,
        resetting: false,
        searchParms: {},
    },
    mutations: {
        setReminders(state, reminders) {
            state.reminders = reminders;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setSending(state, sending) {
            state.sending = sending;
        },
        setResetting(state, resetting) {
            state.resetting = resetting;
        },
        setSearchParams(state, searchParams) {
            state.searchParams = searchParams;
        }
    },
    actions: {
        searchReminders({ commit }, searchParams) {
            commit('setLoading', true)
            commit('setSearchParams', searchParams);
            Service.search(searchParams)
                .then((res) => {
                    commit('setReminders', res.data)
                })
                .catch((err) => {
                    window.alert('Error: Could not load service reminders')
                    throw err
                })
                .then(() => {
                    commit('setLoading', false)
                })
        },
        refreshReminder({commit, state}, reminderId) {
            const index = state.reminders.findIndex(r => r.id === reminderId);
            if (index < 0) {
                return;
            }
            const reminders = [...state.reminders];
            Service.find(reminderId).then(({data}) => {
                reminders[index] = data;
                commit('setReminders', reminders);
            })
        },
        sendReminders({dispatch, state}) {
            const sitesCount = state.reminders.length;
            const confirm = window.confirm(
                `Send email reminders to ${sitesCount} sites?`
            );
            if (!confirm) {
                return;
            }
            let reminderIds = state.reminders
                .flat()
                .filter((r) => r.status === "due")
                .map((r) => r.id);
            dispatch('sendRemindersByIds', reminderIds);
        },
        sendRemindersByIds({commit, dispatch}, reminderIds) {
            commit('setSending', true);
            dispatch('setInfoMessage', "Sending reminders, please wait...");
            Service.send(reminderIds)
                .then(({ data }) => {
                    let sent = data.sent.length;
                    let failed = data.failed.length;
                    let messages = [];
                    if (sent) {
                        messages.push(`Sent ${sent} reminder(s)`);
                    }
                    if (failed) {
                        messages.push(`${failed} reminder(s) failed to send`);
                    }
                    dispatch('setInfoMessage', messages.join(", "));

                    const errors = [];
                    const failedReminders = data.failed || [];
                    failedReminders.forEach(function (reminder) {
                        if (!reminder || !reminder.error) {
                            return;
                        }
                        if (errors.indexOf(reminder.error) === -1) {
                            errors.push(reminder.error);
                        }
                    });
                    if (errors.length) {
                        commit('setErrorMessage', errors.join(' '), { root: true });
                    }
                })
                .catch((err) => {
                    dispatch(
                        'setInfoMessage',
                        "Error: Failed to send service reminders"
                    );
                    throw err;
                })
                .then(() => {
                    commit('setSending', false);
                });
        },
        resetReminders({commit, state}) {
            if(!state.searchParams) {
                console.error('Failed to reset reminders, search params for service reminders not set');
                return;
            }
            const confirm = window.confirm(
                "Are you sure you want to reset all service reminders for " +
                    this.searchDate.format("MMMM") +
                    "?"
            );
            if (!confirm) {
                return;
            }
            commit('setResetting', true)
            Service.updateStatuses(
                state.searchParms.month,
                "due"
            ).then(() => {
                commit('setResetting', false);
            });
        },
        sendReminder({dispatch, state}, reminder) {
            const confirm = window.confirm(
                `Send email reminder to ${reminder.site.customer.company_name}: ${reminder.site.name}?`
            );
            if (!confirm) {
                return;
            }
            const reminderIds = state.reminders.filter(r => r.site_id === reminder.site_id).map(r => r.id);
            dispatch('sendRemindersByIds', reminderIds);
        },
        sendAllUnsentReminders({dispatch, state}) {
            const remindersToSend = state.reminders.filter(r => !r.sent).map(r => r.id);
            dispatch('sendRemindersByIds', remindersToSend);
        }
        
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/serviceReminders.js